document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openMenu = event.target.closest('.site-header details[open]');
  if (!openMenu) return;
  openMenu.open = false;
  openMenu.querySelector('summary')?.focus();
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.site-header details[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
